import { HttpInterceptorFn } from '@angular/common/http';
import { inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { environment } from '../../environments/environment';

/**
 * Aggiunge l'header Authorization (Bearer token) a tutte le chiamate verso la
 * nostra API. Centralizza la logica che prima era nel metodo setHeader() di
 * ConnectionService. Le richieste verso altri host (es. asset, servizi esterni)
 * non vengono toccate.
 */
export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const platformId = inject(PLATFORM_ID);

  // Solo le chiamate verso il backend Nyzed ricevono il token.
  if (!req.url.startsWith(environment.apiUrl)) {
    return next(req);
  }

  const token = isPlatformBrowser(platformId)
    ? localStorage.getItem('token') || ''
    : '';

  // withCredentials sempre attivo verso la nostra API: è ciò che permette al
  // cookie httpOnly del refresh token di viaggiare (login/refresh/logout).
  // Authorization solo se c'è un token (al login non c'è ancora).
  return next(
    req.clone({
      withCredentials: true,
      setHeaders: token ? { Authorization: `Bearer ${token}` } : {},
    }),
  );
};
